import { IdAmbito } from 'shell/constants/id-ambito';

export const getBaseUrl = (scope?: string, idCat?: string): string => {
  if (idCat) {
    return `/stato-civile/notifiche-da-stato-civile/${idCat}`;
  }

  if (!scope) {
    return '/notifiche-da-stato-civile';
  }

  switch (scope) {
    case IdAmbito.Iscrizioni:
      return '/iscrizioni/notifiche-da-stato-civile';
    case IdAmbito.Mutazioni:
      return '/mutazioni/notifiche-da-stato-civile';
    case IdAmbito.Cancellazioni:
      return '/cancellazioni/notifiche-da-stato-civile';
    default:
      return '';
  }
};
